import { createReducer } from '@reduxjs/toolkit';
import { ModelingState } from '../../pages/customer-profile/components/Tabs/ModelingTab/interfaces';

const initialState: ModelingState = {
  status: '',
  generatedAt: null,
  statusLoading: false,
  triggerLoading: false,
  logsLoading: false,
  inputsLoading: false,
};

const modelingReducer = createReducer(initialState, {
  GET_MODELING_STATUS_REQUESTED(state) {
    state.statusLoading = true;
  },
  GET_MODELING_STATUS_SUCCEEDED(state, action) {
    const { status, generatedAt } = action.payload;
    state.status = status;
    state.generatedAt = generatedAt;
    state.statusLoading = false;
  },
  GET_MODELING_STATUS_ERROR(state) {
    state.statusLoading = false;
    state.status = '';
  },

  TRIGGER_MODELING_REQUESTED(state) {
    state.triggerLoading = true;
  },
  TRIGGER_MODELING_SUCCEEDED(state, action) {
    const { status, generatedAt } = action.payload;
    state.status = status;
    state.generatedAt = generatedAt;
    state.triggerLoading = false;
  },
  TRIGGER_MODELING_ERROR(state, action) {
    const { status, generatedAt } = action.payload;
    state.triggerLoading = false;
    state.status = status;
    state.generatedAt = generatedAt;
  },

  DOWNLOAD_MODELING_LOGS_REQUESTED(state) {
    state.logsLoading = true;
  },
  DOWNLOAD_MODELING_LOGS_SUCCEEDED(state) {
    state.logsLoading = false;
  },
  DOWNLOAD_MODELING_LOGS_ERROR(state) {
    state.logsLoading = false;
  },

  DOWNLOAD_MODELING_INPUTS_REQUESTED(state) {
    state.inputsLoading = true;
  },
  DOWNLOAD_MODELING_INPUTS_SUCCEEDED(state) {
    state.inputsLoading = false;
  },
  DOWNLOAD_MODELING_INPUTS_ERROR(state) {
    state.inputsLoading = false;
  },
});

export default modelingReducer;
